import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, unref as _unref, createBlock as _createBlock, createTextVNode as _createTextVNode, vModelRadio as _vModelRadio, vModelText as _vModelText, withModifiers as _withModifiers, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/common/icon-arrow-left.svg'
import _imports_1 from '@/assets/img/common/img-pagetop.svg'


const _withScopeId = n => (_pushScopeId("data-v-73c15666"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "l-wrapper",
  style: {"background-color":"#e6eff6"}
}
const _hoisted_2 = { class: "l-wrapper_main" }
const _hoisted_3 = { class: "p-recommend --no-pt-sp" }
const _hoisted_4 = { class: "p-recommend-back" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "戻る",
  width: "24",
  height: "24"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "転職希望アンケート 編集", -1))
const _hoisted_7 = {
  class: "p-recommend-form",
  id: "p-recommend-form",
  action: "",
  method: "post"
}
const _hoisted_8 = { class: "p-recommend-inner -is-form" }
const _hoisted_9 = { class: "p-recommend-form__field js-form-block" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "p-recommend-form__title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "希望する勤務地"),
  /*#__PURE__*/_createElementVNode("span", { class: "-is-required" }, "必須")
], -1))
const _hoisted_11 = { class: "p-recommend-form__error-wrap" }
const _hoisted_12 = { class: "p-recommend-form__set-1" }
const _hoisted_13 = { class: "p-login-form__checkbox" }
const _hoisted_14 = ["checked"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-recommend-form__label",
  for: "form-all-area"
}, "全国可", -1))
const _hoisted_17 = ["onClick", "disabled"]
const _hoisted_18 = ["disabled"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "追加する", -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { class: "p-recommend-form__field" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "p-recommend-form__title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "転居の可能性")
], -1))
const _hoisted_23 = { class: "p-recommend-form__error-wrap" }
const _hoisted_24 = { class: "p-recommend-form__field js-form-block" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "p-recommend-form__title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "希望業種")
], -1))
const _hoisted_26 = { class: "p-recommend-form__error-wrap" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-5" }, "希望度順に1から選択してください", -1))
const _hoisted_28 = ["onClick", "value"]
const _hoisted_29 = ["onClick", "disabled"]
const _hoisted_30 = ["disabled"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "追加する", -1))
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = { class: "p-recommend-form__set-1" }
const _hoisted_34 = { class: "p-login-form__checkbox" }
const _hoisted_35 = ["checked"]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-recommend-form__label",
  for: "all-industy"
}, "こだわらない", -1))
const _hoisted_38 = { class: "p-recommend-form__set-1" }
const _hoisted_39 = { class: "p-login-form__checkbox" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-recommend-form__label",
  for: "industy-jobs"
}, [
  /*#__PURE__*/_createTextVNode("これまでに経験した業種"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("small", null, "（職務要約に入力されている内容を自動で反映します）")
], -1))
const _hoisted_42 = { class: "p-recommend-form__field js-form-block" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "p-recommend-form__title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "希望職種"),
  /*#__PURE__*/_createElementVNode("span", { class: "-is-required" }, "必須")
], -1))
const _hoisted_44 = { class: "p-recommend-form__error-wrap" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-5" }, "希望度順に1から選択してください", -1))
const _hoisted_46 = ["onClick", "disabled"]
const _hoisted_47 = ["disabled"]
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "追加する", -1))
const _hoisted_49 = [
  _hoisted_48
]
const _hoisted_50 = { class: "p-recommend-form__set-1" }
const _hoisted_51 = { class: "p-login-form__checkbox" }
const _hoisted_52 = ["checked"]
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-recommend-form__label",
  for: "all-jobs"
}, "こだわらない", -1))
const _hoisted_55 = { class: "p-recommend-form__set-1" }
const _hoisted_56 = { class: "p-login-form__checkbox" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-recommend-form__label",
  for: "experience-jobs"
}, [
  /*#__PURE__*/_createTextVNode("これまでに経験した職種"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("small", null, "（職務要約に入力されている内容を自動で反映します）")
], -1))
const _hoisted_59 = { class: "p-recommend-form__field" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "p-recommend-form__title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "希望する従業員数")
], -1))
const _hoisted_61 = { class: "p-recommend-form__error-wrap" }
const _hoisted_62 = { class: "p-recommend-form__field js-form-block" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "p-recommend-form__title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "希望する年収")
], -1))
const _hoisted_64 = { class: "p-recommend-form__error-wrap" }
const _hoisted_65 = { class: "--col-8px --no-wrap js-entry-item" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "万円", -1))
const _hoisted_67 = { class: "p-recommend-form__set-1" }
const _hoisted_68 = { class: "p-login-form__checkbox" }
const _hoisted_69 = ["checked"]
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-recommend-form__label",
  for: "all-salary"
}, "こだわらない", -1))
const _hoisted_72 = { class: "p-recommend-form__field js-form-block" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "p-recommend-form__title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "最低希望年収"),
  /*#__PURE__*/_createElementVNode("span", { class: "-is-required" }, "必須")
], -1))
const _hoisted_74 = { class: "p-recommend-form__error-wrap" }
const _hoisted_75 = { class: "p-recommend-form__list-1 js-entry-list" }
const _hoisted_76 = { class: "--col-8px --no-wrap js-entry-item" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "万円", -1))
const _hoisted_78 = { class: "p-recommend-form__field" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "p-recommend-form__title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "転職希望時期")
], -1))
const _hoisted_80 = { class: "p-recommend-form__error-wrap" }
const _hoisted_81 = { class: "p-recommend-form__field" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "p-recommend-form__title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "転職理由、転職を考えたきっかけ"),
  /*#__PURE__*/_createElementVNode("span", { class: "-is-required" }, "必須")
], -1))
const _hoisted_83 = { class: "p-recommend-form__error-wrap" }
const _hoisted_84 = { class: "p-recommend-form__field" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "p-recommend-form__title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "転職で優先したいこと、叶えたいこと"),
  /*#__PURE__*/_createElementVNode("span", { class: "-is-required" }, "必須")
], -1))
const _hoisted_86 = { class: "p-recommend-form__error-wrap" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-5" }, "言葉としてまとまっていなくても結構でございますので、率直なお気持ちをお教えください。", -1))
const _hoisted_88 = { class: "p-recommend-form__field" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "p-recommend-form__title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "転職活動で利用しているもの")
], -1))
const _hoisted_90 = { class: "p-recommend-form__error-wrap" }
const _hoisted_91 = { class: "p-recommend-form__set-2 js-radio-area" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, "転職エージェント", -1))
const _hoisted_93 = { class: "p-recommend-form__set-2-group" }
const _hoisted_94 = { class: "p-login-form__radio" }
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-recommend-form__label",
  for: "form-current-search-01-yes"
}, "あり", -1))
const _hoisted_97 = { class: "p-recommend-form__set-2-group" }
const _hoisted_98 = { class: "p-login-form__radio" }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-recommend-form__label",
  for: "form-current-search-01-no"
}, "なし", -1))
const _hoisted_101 = { class: "p-recommend-form__set-2 js-radio-area" }
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, "転職サイト", -1))
const _hoisted_103 = { class: "p-recommend-form__set-2-group" }
const _hoisted_104 = { class: "p-login-form__radio" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-recommend-form__label",
  for: "form-current-search-02-yes"
}, "あり", -1))
const _hoisted_107 = { class: "p-recommend-form__set-2-group" }
const _hoisted_108 = { class: "p-login-form__radio" }
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-recommend-form__label",
  for: "form-current-search-02-no"
}, "なし", -1))
const _hoisted_111 = { class: "p-recommend-form__set-2" }
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, "ハローワーク", -1))
const _hoisted_113 = { class: "p-recommend-form__error-wrap" }
const _hoisted_114 = { class: "p-recommend-form__set-2-group" }
const _hoisted_115 = { class: "p-login-form__radio" }
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-recommend-form__label",
  for: "form-current-search-03-yes"
}, "あり", -1))
const _hoisted_118 = { class: "p-recommend-form__set-2-group" }
const _hoisted_119 = { class: "p-login-form__radio" }
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-recommend-form__label",
  for: "form-current-search-03-no"
}, "なし", -1))
const _hoisted_122 = { class: "p-recommend-form__field js-form-block" }
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "p-recommend-form__title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "転職活動状況")
], -1))
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-2" }, [
  /*#__PURE__*/_createTextVNode("既に選考が進んでいらっしゃる企業がある場合に重複のご紹介を避けるため、またご希望を正確に把握するためにお教えください。 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("※許可なく企業へ開示することはございませんので、ご安心下さい ")
], -1))
const _hoisted_125 = {
  class: "p-recommend-form__list-2 js-entry-list",
  "data-entries": "3"
}
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "p-recommend-form__heading-1" }, "企業", -1))
const _hoisted_127 = { class: "p-recommend-form__error-wrap" }
const _hoisted_128 = { class: "p-recommend-form__group-1" }
const _hoisted_129 = { class: "p-recommend-form__group-1-field" }
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, "企業名", -1))
const _hoisted_131 = ["onUpdate:modelValue"]
const _hoisted_132 = { class: "p-recommend-form__group-1-field" }
const _hoisted_133 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, "選考フェーズ", -1))
const _hoisted_134 = { class: "p-recommend-form__group-1-field" }
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, "志望度", -1))
const _hoisted_136 = { class: "p-recommend-form__group-1-field" }
const _hoisted_137 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, "経路", -1))
const _hoisted_138 = ["onClick", "disabled"]
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "企業", -1))
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "を削除する", -1))
const _hoisted_141 = [
  _hoisted_139,
  _hoisted_140
]
const _hoisted_142 = ["disabled"]
const _hoisted_143 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "企業を追加する", -1))
const _hoisted_144 = [
  _hoisted_143
]
const _hoisted_145 = { class: "p-recommend-form__field js-form-block" }
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "p-recommend-form__title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "応募を検討中の企業")
], -1))
const _hoisted_147 = { class: "p-recommend-form__error-wrap" }
const _hoisted_148 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-2" }, "ご希望をより正確に把握するために、該当企業がある場合はお教えください。", -1))
const _hoisted_149 = { class: "p-recommend-form__set-1" }
const _hoisted_150 = { class: "p-login-form__checkbox" }
const _hoisted_151 = ["checked"]
const _hoisted_152 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_153 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-recommend-form__label",
  for: "form-applying"
}, "特になし", -1))
const _hoisted_154 = { class: "js-entry-item" }
const _hoisted_155 = { class: "p-recommend-form__field" }
const _hoisted_156 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "p-recommend-form__title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "マイナビ転職AGENTを利用する目的・期待すること")
], -1))
const _hoisted_157 = { class: "p-recommend-form__error-wrap" }
const _hoisted_158 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-2" }, "ご希望をより正確に把握するために、該当企業がある場合はお教えください。", -1))
const _hoisted_159 = { class: "p-recommend-form__field" }
const _hoisted_160 = ["onClick"]
const _hoisted_161 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "この内容で保存する", -1))
const _hoisted_162 = [
  _hoisted_161
]
const _hoisted_163 = { class: "l-wrapper_nav" }
const _hoisted_164 = ["onClick"]
const _hoisted_165 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_166 = [
  _hoisted_165
]
const _hoisted_167 = ["onClick"]
const _hoisted_168 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "この内容で保存する", -1))
const _hoisted_169 = [
  _hoisted_168
]

import { nextTick, onMounted, onUnmounted, watch } from 'vue';
import Loading from '@/components/Loading.vue';
import { ref } from 'vue';
import RecommendSelect from './components/RecommendSelect.vue';
import RecommendPurposeAgent from './components/RecommendPurposeAgent.vue';
import IndustryRadio from '@/components/IndustryRadio.vue';
import OccupationRadio from '@/components/OccupationRadio.vue';
import { domHelperUtils } from '@/utils/domHelper';
import { CareerRecommendInfo } from '@/types';
import { useStore } from 'vuex';
import { getCareerInfoRecommendService, updateCareerRecommendService } from '@/api/services/trnCareerService';
import RecommendModal from './components/RecommendModal.vue';
import { AxiosError } from 'axios';
import { isArray } from 'lodash';
import InvalidMessage from '@/components/InvalidMessage.vue';
import { useForm } from 'vee-validate';
import ValidatableField from '@/components/ValidatableField.vue';
import { MYPAGE_CONSTANTS } from '@/constants/mypage';
import { recommendFormUtils } from '@/utils/recommendForm';


export default /*#__PURE__*/_defineComponent({
  __name: 'RecommendFormView',
  setup(__props) {

const storeBase = MYPAGE_CONSTANTS.STORE_MST;
const recommendConst = MYPAGE_CONSTANTS.RECOMMEND;

const isLoading = ref(false);
const showModal = ref(false);
const store = useStore();
const isOtherPurposeChecked = ref(false);
const toEmpty = (v: any) => v ? v : '';
const isTeleportReady = ref(false);
const isDisabledSubmit = ref(false);
const recomendData = ref<CareerRecommendInfo>({});

const recommendForm = useForm();

function scrollToTop() {
  domHelperUtils.scrollToTop();
}

const validateErr = ref<{
  [key: string]: string;
}>({});

const areaItems = ref<number[]>([]);
function addAreaId() {
  if (areaItems.value.length >= recommendConst.MAX_WISH_AREA) return;
  areaItems.value.push(Math.random());
  recomendData.value.wishWkAreaIds?.push(0);
  recommendForm.setFieldValue(`wishWkAreaIds[${areaItems.value.length - 1}]`, '');
}
async function removeAreaId(idx: number) {
  if (areaItems.value.length > 1) {
    for (let i = idx; i < areaItems.value.length - 1; i++) {
      areaItems.value[i] = areaItems.value[i + 1];
      if (isArray(recomendData.value.wishWkAreaIds)){
        recomendData.value.wishWkAreaIds[i] = recomendData.value.wishWkAreaIds[i+1];
        recommendForm.setFieldValue(`wishWkAreaIds[${i}]`, toEmpty(recomendData.value.wishWkAreaIds[i + 1]));
        await recommendForm.validateField(`wishWkAreaIds[${i}]`);
      }
    }

    areaItems.value.pop();
    recomendData.value.wishWkAreaIds?.pop();
  }
}

const refChkCopyIndustry = ref(null);
const industryItems = ref<{
  id: number;
  selectecValue: {
    indsctgId: number;
    indsctgText: string;
  }
  isActive: boolean;
}[]>([]);
function addIndustryId() {
  if (industryItems.value.length >= recommendConst.MAX_WISH_INDUSTRY) return;
  industryItems.value.push({
    id: Math.random(),
    selectecValue: {
      indsctgId: 0,
      indsctgText: '',
    },
    isActive: false,
  });
  recomendData.value.wishIndsCtgIds?.push(0);
}
function removeIndustryId(idx: number) {
  if (industryItems.value.length > 1) {
    industryItems.value.splice(idx, 1);
    recomendData.value.wishIndsCtgIds!.splice(idx, 1);
    unCheckCopyIndustry();
  }
}
function openIndustryDialog(ind: any) {
  ind.isActive = true;
}

const getExpIndsCtgIds = async() =>
{
  const latestRecmData = await getCareerRecomendInfo();
  if (latestRecmData.expIndsCtgIds && latestRecmData.expIndsCtgIds.length > 0) {
    const industries =   await store.dispatch(storeBase.MST_INDUSTRY);
    const industriesFlat = industries.flat(); 
    for(let i = 0; i< latestRecmData.expIndsCtgIds.length; i++)
    {
      const element = latestRecmData.expIndsCtgIds[i];
      if(element && !industriesFlat.some(item => item.id === element))
      {
        return null;
      }
    }
    return latestRecmData;
  }
  else
  {
    return null;
  }
};

async function updateWishIndsFromExpInds(checked: boolean){
  if (checked) {
    const latestRecmData = await getExpIndsCtgIds();
    if (latestRecmData && latestRecmData.expIndsCtgIds && latestRecmData.expIndsCtgIds.length > 0) {      
      recomendData.value.wishIndsCtgNotParticularFlg = 0;
      industryItems.value = [];
      recomendData.value.wishIndsCtgIds = [...latestRecmData.expIndsCtgIds];
      recomendData.value.wishIndsCtgIds.forEach(ind => {
      industryItems.value.push({
        id: Math.random(),
        selectecValue: {
          indsctgId: ind,
          indsctgText: '',
        },
        isActive: false,
      });
    });
    } else {
      (refChkCopyIndustry.value! as HTMLInputElement).checked = false;
      alert('経験業種が登録されていないため、経験業種を登録できませんでした。\n経験業種は「書類作成→職務要約→編集する」よりご確認いただけます。');
    }
  }
}
watch(() => recomendData.value.wishIndsCtgNotParticularFlg, (newVal) => {
  if (newVal && refChkCopyIndustry.value) {
    (refChkCopyIndustry.value as HTMLInputElement).checked = false;
    recomendData.value.wishIndsCtgIds = [0];
    industryItems.value = [{
      id: Math.random(),
      selectecValue: {
        indsctgId: 0,
        indsctgText: '',
      },
      isActive: false,
    }];
  }
});

const refChkCopyOccup = ref(null);
const occupItems = ref<{
  id: number;
  selectecValue: {
    ocupctg3Id: string;
    ocupctg3Text: string;
  }
  isActive: boolean;
}[]>([]);
function addOccupId() {
  if (occupItems.value.length >= recommendConst.MAX_WISH_OCCUP) return;
  occupItems.value.push({
    id: Math.random(),
    selectecValue: {
      ocupctg3Id: '',
      ocupctg3Text: '',
    },
    isActive: false,
  });
  recomendData.value.wishIndsCtgIds?.push(0);
}
function removeOccupId(idx: number) {
  if (occupItems.value.length > 1) {
    occupItems.value.splice(idx, 1);
    recomendData.value.wishIndsCtgIds!.splice(idx, 1);
    unCheckCopyOccup();
  }
}
function openOccupDialog(ind: any) {
  ind.isActive = true;
}

const getExpOcupcTgIds = async() =>
{
  const latestRecmData = await getCareerRecomendInfo();
  if (latestRecmData.expOcupcTgIds && latestRecmData.expOcupcTgIds.length > 0) {
    const ocups =   await store.dispatch(storeBase.MST_OCUP3);
    const ocupsFlat = ocups.flat(); 
    for(let i = 0; i < latestRecmData.expOcupcTgIds.length; i ++)
    {
      const element = latestRecmData.expOcupcTgIds[i];
      if(element && !ocupsFlat.some(item => item.ocupctgid === element))
      {
        return null;
      }
    };
    return latestRecmData;
  }
  else
  {
    return null;
  }
};

async function updateWishOcupFromExpOccup(checked: boolean) {
  if (checked) {
    const latestRecmData = await getExpOcupcTgIds();
    if (latestRecmData && latestRecmData.expOcupcTgIds && latestRecmData.expOcupcTgIds.length > 0) {        
      recomendData.value.wishOcupCtgNotParticalarFlg = 0;
      occupItems.value = [];
      recomendData.value.wishOcupCtgIds = [...latestRecmData.expOcupcTgIds];
      recomendData.value.wishOcupCtgIds.forEach(occ => {
        occupItems.value.push({
          id: Math.random(),
          selectecValue: {
            ocupctg3Id: occ,
            ocupctg3Text: '',
          },
          isActive: false,
        });
      });
    } else {
      (refChkCopyOccup.value! as HTMLInputElement).checked = false;
      alert('経験職種が登録されていないため、経験職種を登録できませんでした。\n経験職種は「書類作成→職務要約→編集する」よりご確認いただけます。');
    }
  }
}
watch(() => recomendData.value.wishOcupCtgNotParticalarFlg, (newVal) => {
  if (newVal && refChkCopyOccup.value) {
    (refChkCopyOccup.value as HTMLInputElement).checked = false;
      occupItems.value = [{
      id: Math.random(),
      selectecValue: {
        ocupctg3Id: '',
        ocupctg3Text: '',
      },
      isActive: false,
    }];
    recomendData.value.wishIndsCtgIds = [0];
  }
});

const jobChangeItems = ref<number[]>([]);
function addJobChange() {
  if (jobChangeItems.value.length >= recommendConst.MAX_JOBCHANGE) return;
  jobChangeItems.value.push(Math.random());
  recomendData.value.lsTrnJobChangeStatus?.push({
    jobChangeStatusId: 0,
    clientNameRemind: '',
    selectionPhaseId: toEmpty(0),
    aspirationId: toEmpty(0),
    courseId: toEmpty(0),
  });
  const len = jobChangeItems.value.length;
  recommendForm.setFieldValue(`lsTrnJobChangeStatus[${len - 1}].clientNameRemind`, '');
  recommendForm.setFieldValue(`lsTrnJobChangeStatus[${len - 1}].selectionPhaseId`, '');
  recommendForm.setFieldValue(`lsTrnJobChangeStatus[${len - 1}].aspirationId`, '');
  recommendForm.setFieldValue(`lsTrnJobChangeStatus[${len - 1}].courseId`, '');
}
async function removeJobChange(idx: number) {
  if (jobChangeItems.value.length > 1) {
    for (let i = idx; i < jobChangeItems.value.length - 1; i++) {
      jobChangeItems.value[i] = jobChangeItems.value[i + 1];
      if (isArray(recomendData.value.lsTrnJobChangeStatus)) {
        const nextItem = recomendData.value.lsTrnJobChangeStatus[i + 1];
        recomendData.value.lsTrnJobChangeStatus[i] = {...nextItem};
        recommendForm.setFieldValue(`lsTrnJobChangeStatus[${i}].clientNameRemind`, toEmpty(nextItem.clientNameRemind));
        recommendForm.setFieldValue(`lsTrnJobChangeStatus[${i}].selectionPhaseId`, toEmpty(nextItem.selectionPhaseId));
        recommendForm.setFieldValue(`lsTrnJobChangeStatus[${i}].aspirationId`, toEmpty(nextItem.aspirationId));
        recommendForm.setFieldValue(`lsTrnJobChangeStatus[${i}].courseId`, toEmpty(nextItem.courseId));
        await recommendForm.validateField(`lsTrnJobChangeStatus[${i}].clientNameRemind`);
      }
    }
    jobChangeItems.value.pop();
    recomendData.value.lsTrnJobChangeStatus!.pop();
  }
}

watch(() => recomendData.value.clientNameRemindOtherFlg, async (newVal) => {
  if (newVal) {
    recomendData.value.clientNameRemindOther = '';
    recommendForm.setFieldValue('clientNameRemindOther', '');
    await recommendForm.validateField('clientNameRemindOther');
  }
});
watch(() => recomendData.value.wishSalaryNotParticularFlg, (newVal) => {
  if (newVal) {
    recomendData.value.wishAnnualIncomeNum = 0;
  }
});

watch(() => recomendData.value.careerChangeAgentFlg, (newVal) => {
  if (!(newVal) || newVal == 2) {
    recomendData.value.careerChangeAgentMemo = '';
    recommendForm.setFieldValue('careerChangeAgentMemo', '');
  }
});
watch(() => recomendData.value.jobChangeSiteFlg, (newVal) => {
  if (!(newVal) || newVal == 2) {
    recomendData.value.jobChangeSiteMemo = '';
    recommendForm.setFieldValue('jobChangeSiteMemo', '');
  }
});

watch(() => recomendData.value.wishWkAreaAllFlg, (newVal) => {
  if (newVal == 1) {
    for (let i = 0; i < areaItems.value.length; i++) {
        recomendData.value.wishWkAreaIds[i] = 0;
        recommendForm.setFieldValue(`wishWkAreaIds[${i}]`, '');
    }
    areaItems.value = [0];
  }
});

function unCheckCopyIndustry()
{
  (refChkCopyIndustry.value! as HTMLInputElement).checked = false;
}

function unCheckCopyOccup()
{
  (refChkCopyOccup.value! as HTMLInputElement).checked = false;
}

async function updateRecommendData() {
   if(isDisabledSubmit.value)
  {
    return;
  }
  else
  {
    isDisabledSubmit.value = true;
  }
  const postData = { ...recomendData.value };
  validateErr.value = {};
  const isEmpty = (val: any) => {
    return val == null || val == undefined || val == '';
  };

  if (postData.wishWkAreaIds) {
    postData.wishWkAreaIds = postData.wishWkAreaIds.map(id => isEmpty(id) ? 0 : id);
    if (postData.wishWkAreaIds.every(id => !id)) {
      postData.wishWkAreaIds = [];
    }
    while (postData.wishWkAreaIds.length < recommendConst.MAX_WISH_AREA) {
      postData.wishWkAreaIds.push(0);
    }
  }
  
  if (!postData.changeAddrFlg) {
    postData.changeAddrFlg = undefined;
  }
  if (postData.wishIndsCtgNotParticularFlg) {
    postData.wishIndsCtgIds = [];
  } else {
    postData.wishIndsCtgIds = industryItems.value.map(i => i.selectecValue.indsctgId);
  }
  if (postData.wishOcupCtgNotParticalarFlg) {
    postData.wishOcupCtgIds = [];
  } else {
    postData.wishOcupCtgIds = occupItems.value.map(i => i.selectecValue.ocupctg3Id);
  }
  if (!postData.wishEmployeeId) {
    postData.wishEmployeeId = undefined;
  }
  if (postData.wishAnnualIncomeNum?.toString() == '') {
    postData.wishAnnualIncomeNum = undefined;
  }

  postData.lsTrnJobChangeStatus?.forEach(job => {
    if (!job.aspirationId) job.aspirationId = undefined;
    if (!job.selectionPhaseId) job.selectionPhaseId = undefined;
    if (!job.courseId) job.courseId = undefined;
  });

  const validateResult = await recommendForm.validate();
  if (!validateResult.valid) {
    await nextTick();
    focusToFirstError();
    isDisabledSubmit.value = false;
    return;
  }

  try {      
    isLoading.value = true;
    const careerInfo = recommendFormUtils.mapperToTrnCareerRecommendUpdateForm(postData);
    await updateCareerRecommendService(careerInfo);
    isLoading.value = false;
    showModal.value = true;
  } catch (error) {
    const response = (error as AxiosError).response;
    if (!response || !isArray(response.data)) return;
    if (response.status == 400) {
      (response.data as any).forEach((err: {
        field: string,
        message: string,
        rejectedValue: string
      }) => {
        recommendForm.setFieldError(err.field, err.message);
      });
      isLoading.value = false;
      await nextTick();
      focusToFirstError();
    }
  }
  isDisabledSubmit.value = false;
}

const getCareerRecomendInfo = async() =>
{   
    const careerInfo = await getCareerInfoRecommendService();    
    if(careerInfo.purposeAgentId)
    {
      const purposeAgentIds = String(careerInfo.purposeAgentId);
      careerInfo.purposeAgentIds = purposeAgentIds.split('/').filter(i => i).map(Number);
    }
    // prcess wishWkArea1~3Id
    if(careerInfo.wishWkAreaId)
    {
      const ids = String(careerInfo.wishWkAreaId).split('/').filter(id => id != '').map(Number);
      while (ids.length > 0 && !ids[ids.length - 1]) {
        ids.pop();
      }
      careerInfo.wishWkAreaIds = ids;
    }

    // process wishIndsCtg1 ~ 6Id
    const lsWishIndsCtgId : number[] = [
        careerInfo.wishIndsCtg1Id??0,
        careerInfo.wishIndsCtg2Id??0,
        careerInfo.wishIndsCtg3Id??0,
        careerInfo.wishIndsCtg4Id??0,
        careerInfo.wishIndsCtg5Id??0,
        careerInfo.wishIndsCtg6Id??0
    ];
    // remove all null value at tail
    while (lsWishIndsCtgId.length > 0 && !lsWishIndsCtgId[lsWishIndsCtgId.length - 1]) {
      lsWishIndsCtgId.pop();
    }
    careerInfo.wishIndsCtgIds = lsWishIndsCtgId;

     // process wishOcupCtg1 ~ 6Id
    const lsWishOcupCtgId : string[] = [
        careerInfo.wishOcupCtg1Id??'',
        careerInfo.wishOcupCtg2Id??'',
        careerInfo.wishOcupCtg3Id??'',
        careerInfo.wishOcupCtg4Id??'',
        careerInfo.wishOcupCtg5Id??'',
        careerInfo.wishOcupCtg6Id??''
    ];
    // remove all null value at tail
    while (lsWishOcupCtgId.length > 0 && !lsWishOcupCtgId[lsWishOcupCtgId.length - 1]) {
        lsWishOcupCtgId.pop();
    }
    careerInfo.wishOcupCtgIds = lsWishOcupCtgId;

     // process expIndsCtg1~6Ids
    const lsExpIndsCtgId : number[] = [
      careerInfo.expIndsCtg1Id??0,
      careerInfo.expIndsCtg2Id??0,
      careerInfo.expIndsCtg3Id??0,
      careerInfo.expIndsCtg4Id??0,
      careerInfo.expIndsCtg5Id??0,
      careerInfo.expIndsCtg6Id??0
    ];
    // remove all null value at tail
    while (lsExpIndsCtgId.length > 0 && !lsExpIndsCtgId[lsExpIndsCtgId.length - 1]) {
      lsExpIndsCtgId.pop();
    }
    careerInfo.expIndsCtgIds = lsExpIndsCtgId;
    // process caExpOcupcTg1 ~ 6Id
    const lsExpOcupcTgId : string[] = [
        careerInfo.expOcupcTg1Id??'',
        careerInfo.expOcupcTg2Id??'',
        careerInfo.expOcupcTg3Id??'',
        careerInfo.expOcupcTg4Id??'',
        careerInfo.expOcupcTg5Id??'',
        careerInfo.expOcupcTg6Id??''
    ];
    // remove all null value at tail
    while (lsExpOcupcTgId.length > 0 && !lsExpOcupcTgId[lsExpOcupcTgId.length - 1]) {
      lsExpOcupcTgId.pop();
    }
    careerInfo.expOcupcTgIds = lsExpOcupcTgId;
    return careerInfo;
};

async function loadRecommendData() {
  isLoading.value = true;
  const recmData = await getCareerRecomendInfo();
  if(!recmData.changeAddrFlg)
  {
    recmData.changeAddrFlg = toEmpty(recmData.changeAddrFlg);
  }

  if (!recmData.wishWkAreaIds || !recmData.wishWkAreaIds.length) {
    recmData.wishWkAreaIds = [0];
  }
  if (!recmData.wishIndsCtgIds || !recmData.wishIndsCtgIds.length) {
    recmData.wishIndsCtgIds = [0];
  }
  if (!recmData.wishOcupCtgIds || !recmData.wishOcupCtgIds.length) {
    recmData.wishOcupCtgIds = [''];
  }
  if (!recmData.lsTrnJobChangeStatus || !recmData.lsTrnJobChangeStatus.length) {
    recmData.lsTrnJobChangeStatus = [{
      jobChangeStatusId:  0,
      clientNameRemind: '',
      selectionPhaseId: 0,
      aspirationId: 0,
      courseId: 0,
    }];
  }

  recmData.wishWkAreaIds.forEach((id, i) => {
    areaItems.value.push(id);
    recommendForm.setFieldValue(`wishWkAreaIds[${i}]`, toEmpty(id));
  });
  recmData.wishIndsCtgIds.forEach(ind => {
    industryItems.value.push({
      id: Math.random(),
      selectecValue: {
        indsctgId: ind,
        indsctgText: '',
      },
      isActive: false,
    });
  });
  recmData.wishOcupCtgIds.forEach(occ => {
    occupItems.value.push({
      id: Math.random(),
      selectecValue: {
        ocupctg3Id: occ,
        ocupctg3Text: '',
      },
      isActive: false,
    });
  });
  recmData.lsTrnJobChangeStatus.forEach((job, i) => {
    jobChangeItems.value.push(job.jobChangeStatusId);
    recommendForm.setFieldValue(`lsTrnJobChangeStatus[${i}].clientNameRemind`, job.clientNameRemind);
  });

  recommendForm.setFieldValue('minWishAnnualIncomeNum', recmData.minWishAnnualIncomeNum);
  recommendForm.setFieldValue('careerChangeAgentMemo', recmData.careerChangeAgentMemo);
  recommendForm.setFieldValue('jobChangeSiteMemo', recmData.jobChangeSiteMemo);
  recommendForm.setFieldValue('changeJobReason', recmData.changeJobReason);
  recommendForm.setFieldValue('changeJobPriority', recmData.changeJobPriority);
  recommendForm.setFieldValue('clientNameRemindOther', recmData.clientNameRemindOther);

  recomendData.value = { ...recmData };

  isLoading.value = false;
}

const focusToFirstError = (): boolean => {
  // Find the first error-message element
  const errorElement: HTMLElement | null = document.querySelector('.--is-error');
  
  if (!errorElement) {
    return false;
  }
  
  // Calculate position with offset
  const elementPosition: number = errorElement.getBoundingClientRect().top;
  const offsetPosition: number = elementPosition + window.pageYOffset - 200;
  
  // Use window.scrollTo if offset needed
  setTimeout(() => {
    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
    errorElement.focus();
  }, 0);

  return true;
};

onMounted(async () => {
  await loadRecommendData();
  domHelperUtils.entryManager.initializeEntryManagement();
  
  // Wait until the browser has finished rendering.
  requestAnimationFrame(() => {
    isTeleportReady.value = true;
  });
});

onUnmounted(() => {
  domHelperUtils.entryManager.removeEntryManagementEvents();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("main", _hoisted_3, [
          _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"]),
          _createElementVNode("p", _hoisted_4, [
            _createVNode(_component_router_link, {
              to: "/recommend/",
              class: "back-link"
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _hoisted_6
          ]),
          _createElementVNode("form", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(InvalidMessage, { name: "wishWkAreaIds[0]" }),
                  _createVNode(InvalidMessage, { name: "wishWkAreaIds[1]" }),
                  _createVNode(InvalidMessage, { name: "wishWkAreaIds[2]" })
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("span", _hoisted_13, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((recomendData.value.wishWkAreaAllFlg) = $event)),
                      checked: !!recomendData.value.wishWkAreaAllFlg,
                      value: "1",
                      class: "js-all",
                      id: "form-all-area",
                      type: "checkbox",
                      name: "form-all-area"
                    }, null, 8, _hoisted_14), [
                      [_vModelCheckbox, recomendData.value.wishWkAreaAllFlg]
                    ]),
                    _hoisted_15
                  ]),
                  _hoisted_16
                ]),
                _createElementVNode("ul", {
                  class: _normalizeClass(["p-recommend-form__list-1 js-entry-list", { '-is-disabled': !!recomendData.value.wishWkAreaAllFlg }]),
                  "data-entries": "3"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(areaItems.value, (t, i) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: t,
                      class: "js-entry-item"
                    }, [
                      (!!recomendData.value.wishWkAreaIds)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createVNode(RecommendSelect, {
                              id: "form-area",
                              name: `wishWkAreaIds[${i}]`,
                              label: `希望する勤務地${i+1}`,
                              rules: {
                          required: !recomendData.value.wishWkAreaAllFlg && recomendData.value.wishWkAreaIds.every(w => !w)
                        },
                              "model-value": recomendData.value.wishWkAreaIds![i],
                              "onUpdate:model-value": ($event: any) => ((recomendData.value.wishWkAreaIds![i]) = $event),
                              className: "p-recommend-form__select"
                            }, null, 8, ["name", "label", "rules", "model-value", "onUpdate:model-value"]),
                            _createElementVNode("button", {
                              class: "p-recommend-form__delete-1",
                              type: "button",
                              onClick: ($event: any) => (removeAreaId(i)),
                              disabled: areaItems.value.length <= 1
                            }, "削除", 8, _hoisted_17)
                          ], 64))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ], 2),
                _createElementVNode("button", {
                  class: "p-recommend-form__add",
                  type: "button",
                  disabled: !!recomendData.value.wishWkAreaAllFlg || areaItems.value.length >= _unref(recommendConst).MAX_WISH_AREA,
                  onClick: addAreaId
                }, _hoisted_20, 8, _hoisted_18)
              ]),
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(InvalidMessage, { name: "changeAddrFlg" })
                ]),
                _createVNode(RecommendSelect, {
                  class: "p-recommend-form__select",
                  id: "form-move",
                  name: "changeAddrFlg",
                  label: "転居の可能性",
                  className: "p-recommend-form__select",
                  "model-value": recomendData.value.changeAddrFlg,
                  "onUpdate:model-value": _cache[1] || (_cache[1] = ($event: any) => ((recomendData.value.changeAddrFlg) = $event))
                }, null, 8, ["model-value"])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("div", _hoisted_26, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(recommendConst).MAX_WISH_INDUSTRY, (num) => {
                    return (_openBlock(), _createBlock(InvalidMessage, {
                      key: num,
                      name: `wishIndsCtg${num}Id`
                    }, null, 8, ["name"]))
                  }), 128))
                ]),
                _hoisted_27,
                _createElementVNode("ul", {
                  class: _normalizeClass(["p-recommend-form__list-1 --numbered", { '-is-disabled': !!recomendData.value.wishIndsCtgNotParticularFlg }])
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(industryItems.value, (ind, i) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: ind.id,
                      class: "js-tab-container js-entry-item"
                    }, [
                      _createElementVNode("input", {
                        class: "p-recommend-form__modal-input-1",
                        onClick: ($event: any) => (openIndustryDialog(ind)),
                        id: "form-industry-type",
                        type: "text",
                        value: ind.selectecValue.indsctgText,
                        name: "form-industry-type",
                        placeholder: "業種を選択",
                        readonly: ""
                      }, null, 8, _hoisted_28),
                      _createElementVNode("button", {
                        class: "p-recommend-form__delete-1",
                        onClick: ($event: any) => (removeIndustryId(i)),
                        type: "button",
                        disabled: industryItems.value.length <= 1
                      }, "削除", 8, _hoisted_29),
                      _createVNode(IndustryRadio, {
                        name: ind.id.toString(),
                        "is-active": ind.isActive,
                        "onUpdate:is-active": ($event: any) => ((ind.isActive) = $event),
                        "selected-industry": ind.selectecValue,
                        "onUpdate:selected-industry": ($event: any) => ((ind.selectecValue) = $event),
                        "onUpdate:setValue": _cache[2] || (_cache[2] = ($event: any) => (unCheckCopyIndustry()))
                      }, null, 8, ["name", "is-active", "onUpdate:is-active", "selected-industry", "onUpdate:selected-industry"])
                    ]))
                  }), 128))
                ], 2),
                _createElementVNode("button", {
                  class: "p-recommend-form__add",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (addIndustryId())),
                  type: "button",
                  disabled: !!recomendData.value.wishIndsCtgNotParticularFlg || industryItems.value.length >= _unref(recommendConst).MAX_WISH_INDUSTRY
                }, _hoisted_32, 8, _hoisted_30),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("span", _hoisted_34, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((recomendData.value.wishIndsCtgNotParticularFlg) = $event)),
                      checked: !!recomendData.value.wishIndsCtgNotParticularFlg,
                      value: "1",
                      class: "js-all",
                      id: "all-industy",
                      type: "checkbox",
                      name: "all-industy"
                    }, null, 8, _hoisted_35), [
                      [_vModelCheckbox, recomendData.value.wishIndsCtgNotParticularFlg]
                    ]),
                    _hoisted_36
                  ]),
                  _hoisted_37
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("span", _hoisted_39, [
                    _createElementVNode("input", {
                      id: "industy-jobs",
                      ref_key: "refChkCopyIndustry",
                      ref: refChkCopyIndustry,
                      type: "checkbox",
                      name: "industy-jobs",
                      onChange: _cache[5] || (_cache[5] = ($event: any) => (updateWishIndsFromExpInds(($event.target as HTMLInputElement).checked)))
                    }, null, 544),
                    _hoisted_40
                  ]),
                  _hoisted_41
                ])
              ]),
              _createElementVNode("div", _hoisted_42, [
                _hoisted_43,
                _createElementVNode("div", _hoisted_44, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(recommendConst).MAX_WISH_OCCUP, (num) => {
                    return (_openBlock(), _createBlock(InvalidMessage, {
                      key: num,
                      name: `wishOcupCtg${num}Id`
                    }, null, 8, ["name"]))
                  }), 128))
                ]),
                _hoisted_45,
                _createElementVNode("ul", {
                  class: _normalizeClass(["p-recommend-form__list-1 --numbered", { '-is-disabled': !!recomendData.value.wishOcupCtgNotParticalarFlg }])
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(occupItems.value, (occ, i) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: occ.id,
                      class: "js-tab-container js-entry-item"
                    }, [
                      _createVNode(ValidatableField, {
                        class: "p-recommend-form__modal-input-1",
                        id: "form-job-type",
                        label: `希望職種${i+1}`,
                        type: "text",
                        rules: {
                          required:  !recomendData.value.wishOcupCtgNotParticalarFlg && occupItems.value.every(w => !w.selectecValue.ocupctg3Id)
                    },
                        value: occ.selectecValue.ocupctg3Text,
                        name: `wishOcupCtg${i+1}Id`,
                        placeholder: "職種を選択",
                        "data-modal-target": "job",
                        onClick: ($event: any) => (openOccupDialog(occ)),
                        readonly: ""
                      }, null, 8, ["label", "rules", "value", "name", "onClick"]),
                      _createElementVNode("button", {
                        class: "p-recommend-form__delete-1",
                        onClick: ($event: any) => (removeOccupId(i)),
                        type: "button",
                        disabled: occupItems.value.length <= 1
                      }, "削除", 8, _hoisted_46),
                      _createVNode(OccupationRadio, {
                        name: occ.id.toString(),
                        "is-active": occ.isActive,
                        "onUpdate:is-active": ($event: any) => ((occ.isActive) = $event),
                        "selected-occupation": occ.selectecValue,
                        "onUpdate:selected-occupation": ($event: any) => ((occ.selectecValue) = $event),
                        "onUpdate:setValue": _cache[6] || (_cache[6] = ($event: any) => (unCheckCopyOccup()))
                      }, null, 8, ["name", "is-active", "onUpdate:is-active", "selected-occupation", "onUpdate:selected-occupation"])
                    ]))
                  }), 128))
                ], 2),
                _createElementVNode("button", {
                  class: "p-recommend-form__add js-add-entry",
                  type: "button",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (addOccupId())),
                  disabled: !!recomendData.value.wishOcupCtgNotParticalarFlg || occupItems.value.length >= _unref(recommendConst).MAX_WISH_OCCUP
                }, _hoisted_49, 8, _hoisted_47),
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("span", _hoisted_51, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((recomendData.value.wishOcupCtgNotParticalarFlg) = $event)),
                      checked: !!recomendData.value.wishOcupCtgNotParticalarFlg,
                      value: "1",
                      class: "js-all",
                      id: "all-jobs",
                      type: "checkbox",
                      name: "all-jobs"
                    }, null, 8, _hoisted_52), [
                      [_vModelCheckbox, recomendData.value.wishOcupCtgNotParticalarFlg]
                    ]),
                    _hoisted_53
                  ]),
                  _hoisted_54
                ]),
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("span", _hoisted_56, [
                    _createElementVNode("input", {
                      id: "experience-jobs",
                      ref_key: "refChkCopyOccup",
                      ref: refChkCopyOccup,
                      type: "checkbox",
                      name: "experience-jobs",
                      onChange: _cache[9] || (_cache[9] = ($event: any) => (updateWishOcupFromExpOccup(($event.target as HTMLInputElement).checked)))
                    }, null, 544),
                    _hoisted_57
                  ]),
                  _hoisted_58
                ])
              ]),
              _createElementVNode("div", _hoisted_59, [
                _hoisted_60,
                _createElementVNode("div", _hoisted_61, [
                  _createVNode(InvalidMessage, { name: "wishEmployeeId" })
                ]),
                _createVNode(RecommendSelect, {
                  className: "p-recommend-form__select",
                  "model-value": recomendData.value.wishEmployeeId,
                  "onUpdate:model-value": _cache[10] || (_cache[10] = ($event: any) => ((recomendData.value.wishEmployeeId) = $event)),
                  id: "form-employees",
                  name: "wishEmployeeId"
                }, null, 8, ["model-value"])
              ]),
              _createElementVNode("div", _hoisted_62, [
                _hoisted_63,
                _createElementVNode("div", _hoisted_64, [
                  _createVNode(InvalidMessage, { name: "wishAnnualIncomeNum" })
                ]),
                _createElementVNode("ul", {
                  class: _normalizeClass(["p-recommend-form__list-1 js-entry-list", {'-is-disabled': !!recomendData.value.wishSalaryNotParticularFlg}])
                }, [
                  _createElementVNode("li", _hoisted_65, [
                    _createVNode(ValidatableField, {
                      class: "p-recommend-form__modal-input-2",
                      value: recomendData.value.wishAnnualIncomeNum,
                      "model-value": recomendData.value.wishAnnualIncomeNum,
                      "onUpdate:model-value": _cache[11] || (_cache[11] = ($event: any) => ((recomendData.value.wishAnnualIncomeNum) = $event)),
                      id: "form-salary",
                      rules: "numeric|max:4",
                      maxlength: "4",
                      name: "wishAnnualIncomeNum",
                      label: "希望する年収",
                      placeholder: "0"
                    }, null, 8, ["value", "model-value"]),
                    _hoisted_66
                  ])
                ], 2),
                _createElementVNode("div", _hoisted_67, [
                  _createElementVNode("span", _hoisted_68, [
                    _withDirectives(_createElementVNode("input", {
                      class: "js-all",
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((recomendData.value.wishSalaryNotParticularFlg) = $event)),
                      value: "1",
                      id: "all-salary",
                      checked: !!recomendData.value.wishSalaryNotParticularFlg,
                      type: "checkbox",
                      name: "all-salary"
                    }, null, 8, _hoisted_69), [
                      [_vModelCheckbox, recomendData.value.wishSalaryNotParticularFlg]
                    ]),
                    _hoisted_70
                  ]),
                  _hoisted_71
                ])
              ]),
              _createElementVNode("div", _hoisted_72, [
                _hoisted_73,
                _createElementVNode("div", _hoisted_74, [
                  _createVNode(InvalidMessage, { name: "minWishAnnualIncomeNum" })
                ]),
                _createElementVNode("ul", _hoisted_75, [
                  _createElementVNode("li", _hoisted_76, [
                    _createVNode(ValidatableField, {
                      value: recomendData.value.minWishAnnualIncomeNum,
                      "model-value": recomendData.value.minWishAnnualIncomeNum,
                      "onUpdate:model-value": _cache[13] || (_cache[13] = ($event: any) => ((recomendData.value.minWishAnnualIncomeNum) = $event)),
                      class: "p-recommend-form__modal-input-2",
                      id: "form-salary-min",
                      rules: "required|numeric|max:4",
                      maxlength: "4",
                      name: "minWishAnnualIncomeNum",
                      label: "最低希望年収",
                      placeholder: "0"
                    }, null, 8, ["value", "model-value"]),
                    _hoisted_77
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_78, [
                _hoisted_79,
                _createElementVNode("div", _hoisted_80, [
                  _createVNode(InvalidMessage, { name: "jobChangeFlg" })
                ]),
                _createVNode(RecommendSelect, {
                  className: "p-recommend-form__select",
                  "model-value": recomendData.value.jobChangeFlg,
                  "onUpdate:model-value": _cache[14] || (_cache[14] = ($event: any) => ((recomendData.value.jobChangeFlg) = $event)),
                  id: "form-relocate",
                  name: "jobChangeFlg",
                  label: "転職希望時期"
                }, null, 8, ["model-value"])
              ]),
              _createElementVNode("div", _hoisted_81, [
                _hoisted_82,
                _createElementVNode("div", _hoisted_83, [
                  _createVNode(InvalidMessage, { name: "changeJobReason" })
                ]),
                _createVNode(ValidatableField, {
                  as: "textarea",
                  name: "changeJobReason",
                  label: "転職理由、転職を考えたきっかけ",
                  value: recomendData.value.changeJobReason,
                  "model-value": recomendData.value.changeJobReason,
                  "onUpdate:model-value": _cache[15] || (_cache[15] = ($event: any) => ((recomendData.value.changeJobReason) = $event)),
                  class: "p-recommend-form__textarea",
                  id: "form-reason-01",
                  rules: "required|max:1000",
                  maxlength: "1000",
                  placeholder: "例）自分のスキルを上げられる職場や案件がある会社で働きたい／結婚や引っ越しなど生活環境に変化があったため"
                }, null, 8, ["value", "model-value"])
              ]),
              _createElementVNode("div", _hoisted_84, [
                _hoisted_85,
                _createElementVNode("div", _hoisted_86, [
                  _createVNode(InvalidMessage, { name: "changeJobPriority" })
                ]),
                _hoisted_87,
                _createVNode(ValidatableField, {
                  as: "textarea",
                  name: "changeJobPriority",
                  label: "転職で優先したいこと、叶えたいこと",
                  value: recomendData.value.changeJobPriority,
                  "model-value": recomendData.value.changeJobPriority,
                  "onUpdate:model-value": _cache[16] || (_cache[16] = ($event: any) => ((recomendData.value.changeJobPriority) = $event)),
                  class: "p-recommend-form__textarea",
                  id: "form-reason-02",
                  rules: "required|max:1000",
                  maxlength: "1000",
                  placeholder: "例）ワークライフバランスを重要視したい／●●職種を軸に転職したい／年収アップさせたい"
                }, null, 8, ["value", "model-value"])
              ]),
              _createElementVNode("div", _hoisted_88, [
                _hoisted_89,
                _createElementVNode("div", _hoisted_90, [
                  _createVNode(InvalidMessage, { name: "careerChangeAgentFlg" }),
                  _createVNode(InvalidMessage, { name: "careerChangeAgentMemo" }),
                  _createVNode(InvalidMessage, { name: "jobChangeSiteFlg" }),
                  _createVNode(InvalidMessage, { name: "jobChangeSiteMemo" })
                ]),
                _createElementVNode("div", _hoisted_91, [
                  _hoisted_92,
                  _createElementVNode("div", _hoisted_93, [
                    _createElementVNode("span", _hoisted_94, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((recomendData.value.careerChangeAgentFlg) = $event)),
                        class: "js-radio-button",
                        id: "form-current-search-01-yes",
                        type: "radio",
                        name: "form-current-search-01",
                        value: "1",
                        "data-true": "true"
                      }, null, 512), [
                        [_vModelRadio, recomendData.value.careerChangeAgentFlg]
                      ]),
                      _hoisted_95
                    ]),
                    _hoisted_96
                  ]),
                  _createElementVNode("div", _hoisted_97, [
                    _createElementVNode("span", _hoisted_98, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((recomendData.value.careerChangeAgentFlg) = $event)),
                        class: "js-radio-button",
                        id: "form-current-search-01-no",
                        type: "radio",
                        name: "form-current-search-01",
                        value: "2",
                        "data-true": "false"
                      }, null, 512), [
                        [_vModelRadio, recomendData.value.careerChangeAgentFlg]
                      ]),
                      _hoisted_99
                    ]),
                    _hoisted_100
                  ]),
                  _createVNode(ValidatableField, {
                    value: recomendData.value.careerChangeAgentMemo,
                    "model-value": recomendData.value.careerChangeAgentMemo,
                    "onUpdate:model-value": _cache[19] || (_cache[19] = ($event: any) => ((recomendData.value.careerChangeAgentMemo) = $event)),
                    class: _normalizeClass(["p-recommend-form__modal-input-2 js-input-area", {'-is-disabled': !(recomendData.value.careerChangeAgentFlg) || recomendData.value.careerChangeAgentFlg == 2}]),
                    id: "form-current-search-01-text",
                    name: "careerChangeAgentMemo",
                    label: "転職エージェント",
                    placeholder: "例）マイナビ転職AGENT",
                    rules: {
                    required: (recomendData.value.careerChangeAgentFlg == 1),
                    max: 100
                  },
                    maxlength: "100"
                  }, null, 8, ["value", "model-value", "class", "rules"])
                ]),
                _createElementVNode("div", _hoisted_101, [
                  _hoisted_102,
                  _createElementVNode("div", _hoisted_103, [
                    _createElementVNode("span", _hoisted_104, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((recomendData.value.jobChangeSiteFlg) = $event)),
                        class: "js-radio-button",
                        id: "form-current-search-02-yes",
                        type: "radio",
                        name: "form-current-search-02",
                        value: "1",
                        "data-true": "true"
                      }, null, 512), [
                        [_vModelRadio, recomendData.value.jobChangeSiteFlg]
                      ]),
                      _hoisted_105
                    ]),
                    _hoisted_106
                  ]),
                  _createElementVNode("div", _hoisted_107, [
                    _createElementVNode("span", _hoisted_108, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((recomendData.value.jobChangeSiteFlg) = $event)),
                        class: "js-radio-button",
                        id: "form-current-search-02-no",
                        type: "radio",
                        name: "form-current-search-02",
                        value: "2",
                        "data-true": "false"
                      }, null, 512), [
                        [_vModelRadio, recomendData.value.jobChangeSiteFlg]
                      ]),
                      _hoisted_109
                    ]),
                    _hoisted_110
                  ]),
                  _createVNode(ValidatableField, {
                    value: recomendData.value.jobChangeSiteMemo,
                    "model-value": recomendData.value.jobChangeSiteMemo,
                    "onUpdate:model-value": _cache[22] || (_cache[22] = ($event: any) => ((recomendData.value.jobChangeSiteMemo) = $event)),
                    class: _normalizeClass(["p-recommend-form__modal-input-2 js-input-area", {'-is-disabled': !(recomendData.value.jobChangeSiteFlg) || recomendData.value.jobChangeSiteFlg == 2}]),
                    id: "form-current-search-02-text",
                    type: "text",
                    name: "jobChangeSiteMemo",
                    label: "転職サイト",
                    placeholder: "例）マイナビ転職",
                    rules: {
                    required: (recomendData.value.jobChangeSiteFlg == 1),
                    max: 100
                  },
                    maxlength: "100"
                  }, null, 8, ["value", "model-value", "class", "rules"])
                ]),
                _createElementVNode("div", _hoisted_111, [
                  _hoisted_112,
                  _createElementVNode("div", _hoisted_113, [
                    _createVNode(InvalidMessage, { name: "helloWorkFlg" })
                  ]),
                  _createElementVNode("div", _hoisted_114, [
                    _createElementVNode("span", _hoisted_115, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((recomendData.value.helloWorkFlg) = $event)),
                        id: "form-current-search-03-yes",
                        type: "radio",
                        name: "form-current-search-03",
                        value: "1"
                      }, null, 512), [
                        [_vModelRadio, recomendData.value.helloWorkFlg]
                      ]),
                      _hoisted_116
                    ]),
                    _hoisted_117
                  ]),
                  _createElementVNode("div", _hoisted_118, [
                    _createElementVNode("span", _hoisted_119, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((recomendData.value.helloWorkFlg) = $event)),
                        id: "form-current-search-03-no",
                        type: "radio",
                        name: "form-current-search-03",
                        value: "2"
                      }, null, 512), [
                        [_vModelRadio, recomendData.value.helloWorkFlg]
                      ]),
                      _hoisted_120
                    ]),
                    _hoisted_121
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_122, [
                _hoisted_123,
                _hoisted_124,
                _createElementVNode("ul", _hoisted_125, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(jobChangeItems.value, (job, i) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: job,
                      class: "js-entry-item"
                    }, [
                      _hoisted_126,
                      _createElementVNode("div", _hoisted_127, [
                        _createVNode(InvalidMessage, {
                          name: `lsTrnJobChangeStatus[${i}].clientNameRemind`
                        }, null, 8, ["name"]),
                        _createVNode(InvalidMessage, {
                          name: `lsTrnJobChangeStatus[${i}].selectionPhaseId`
                        }, null, 8, ["name"]),
                        _createVNode(InvalidMessage, {
                          name: `lsTrnJobChangeStatus[${i}].aspirationId`
                        }, null, 8, ["name"]),
                        _createVNode(InvalidMessage, {
                          name: `lsTrnJobChangeStatus[${i}].courseId`
                        }, null, 8, ["name"])
                      ]),
                      _createElementVNode("div", _hoisted_128, [
                        _createElementVNode("div", _hoisted_129, [
                          _hoisted_130,
                          _withDirectives(_createElementVNode("input", {
                            type: "hidden",
                            id: "form-industry-id",
                            "onUpdate:modelValue": ($event: any) => ((recomendData.value.lsTrnJobChangeStatus![i].jobChangeStatusId) = $event)
                          }, null, 8, _hoisted_131), [
                            [_vModelText, recomendData.value.lsTrnJobChangeStatus![i].jobChangeStatusId]
                          ]),
                          _createVNode(ValidatableField, {
                            value: recomendData.value.lsTrnJobChangeStatus![i].clientNameRemind,
                            "model-value": recomendData.value.lsTrnJobChangeStatus![i].clientNameRemind,
                            "onUpdate:model-value": ($event: any) => ((recomendData.value.lsTrnJobChangeStatus![i].clientNameRemind) = $event),
                            name: `lsTrnJobChangeStatus[${i}].clientNameRemind`,
                            label: "企業名",
                            class: "p-recommend-form__modal-input-2",
                            id: "form-industry-name",
                            maxlength: "100",
                            rules: "max:100",
                            placeholder: "企業名を入力してください"
                          }, null, 8, ["value", "model-value", "onUpdate:model-value", "name"])
                        ]),
                        _createElementVNode("div", _hoisted_132, [
                          _hoisted_133,
                          _createVNode(RecommendSelect, {
                            name: `lsTrnJobChangeStatus[${i}].selectionPhaseId`,
                            className: "p-recommend-form__select",
                            id: "form-industry-fase",
                            label: "選考フェーズ",
                            "model-value": recomendData.value.lsTrnJobChangeStatus![i].selectionPhaseId,
                            "onUpdate:model-value": ($event: any) => ((recomendData.value.lsTrnJobChangeStatus![i].selectionPhaseId) = $event)
                          }, null, 8, ["name", "model-value", "onUpdate:model-value"])
                        ]),
                        _createElementVNode("div", _hoisted_134, [
                          _hoisted_135,
                          _createVNode(RecommendSelect, {
                            className: "p-recommend-form__select",
                            id: "form-industry-interest",
                            name: `lsTrnJobChangeStatus[${i}].aspirationId`,
                            "model-value": recomendData.value.lsTrnJobChangeStatus![i].aspirationId,
                            "onUpdate:model-value": ($event: any) => ((recomendData.value.lsTrnJobChangeStatus![i].aspirationId) = $event)
                          }, null, 8, ["name", "model-value", "onUpdate:model-value"])
                        ]),
                        _createElementVNode("div", _hoisted_136, [
                          _hoisted_137,
                          _createVNode(RecommendSelect, {
                            className: "p-recommend-form__select",
                            id: "form-industry-route",
                            name: `lsTrnJobChangeStatus[${i}].courseId`,
                            "model-value": recomendData.value.lsTrnJobChangeStatus![i].courseId,
                            "onUpdate:model-value": ($event: any) => ((recomendData.value.lsTrnJobChangeStatus![i].courseId) = $event)
                          }, null, 8, ["name", "model-value", "onUpdate:model-value"])
                        ])
                      ]),
                      _createElementVNode("button", {
                        class: "p-recommend-form__delete-2",
                        type: "button",
                        onClick: ($event: any) => (removeJobChange(i)),
                        disabled: recomendData.value.lsTrnJobChangeStatus && recomendData.value.lsTrnJobChangeStatus.length <= 1
                      }, _hoisted_141, 8, _hoisted_138)
                    ]))
                  }), 128))
                ]),
                _createElementVNode("button", {
                  class: "p-recommend-form__add",
                  type: "button",
                  onClick: addJobChange,
                  disabled: recomendData.value.lsTrnJobChangeStatus && recomendData.value.lsTrnJobChangeStatus!.length >= _unref(recommendConst).MAX_JOBCHANGE
                }, _hoisted_144, 8, _hoisted_142)
              ]),
              _createElementVNode("div", _hoisted_145, [
                _hoisted_146,
                _createElementVNode("div", _hoisted_147, [
                  _createVNode(InvalidMessage, { name: "clientNameRemindOther" })
                ]),
                _hoisted_148,
                _createElementVNode("div", _hoisted_149, [
                  _createElementVNode("span", _hoisted_150, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((recomendData.value.clientNameRemindOtherFlg) = $event)),
                      checked: !!recomendData.value.clientNameRemindOtherFlg,
                      value: "1",
                      class: "js-all",
                      id: "form-applying",
                      type: "checkbox",
                      name: "form-applying"
                    }, null, 8, _hoisted_151), [
                      [_vModelCheckbox, recomendData.value.clientNameRemindOtherFlg]
                    ]),
                    _hoisted_152
                  ]),
                  _hoisted_153
                ]),
                _createElementVNode("ul", {
                  class: _normalizeClass(["p-recommend-form__list-1 js-entry-list", {'-is-disabled': !!recomendData.value.clientNameRemindOtherFlg}]),
                  "data-entries": "1"
                }, [
                  _createElementVNode("li", _hoisted_154, [
                    _createVNode(ValidatableField, {
                      value: recomendData.value.clientNameRemindOther,
                      "model-value": recomendData.value.clientNameRemindOther,
                      "onUpdate:model-value": _cache[26] || (_cache[26] = ($event: any) => ((recomendData.value.clientNameRemindOther) = $event)),
                      class: "p-recommend-form__modal-input-2",
                      maxlength: "100",
                      rules: "max:100",
                      id: "form-applying-name",
                      name: "clientNameRemindOther",
                      label: "応募を検討中の企業",
                      placeholder: "例）株式会社マイナビ"
                    }, null, 8, ["value", "model-value"])
                  ])
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_155, [
                _hoisted_156,
                _createElementVNode("div", _hoisted_157, [
                  _createVNode(InvalidMessage, { name: "purposeAgentIds" }),
                  _createVNode(InvalidMessage, { name: "purposeAgentMemo" })
                ]),
                _createTextVNode(),
                _hoisted_158,
                _createVNode(RecommendPurposeAgent, {
                  "model-value": recomendData.value.purposeAgentIds,
                  "onUpdate:model-value": _cache[27] || (_cache[27] = ($event: any) => ((recomendData.value.purposeAgentIds) = $event)),
                  "textarea-value": recomendData.value.purposeAgentMemo,
                  "onUpdate:textarea-value": _cache[28] || (_cache[28] = ($event: any) => ((recomendData.value.purposeAgentMemo) = $event)),
                  "other-checked": isOtherPurposeChecked.value,
                  "onUpdate:other-checked": _cache[29] || (_cache[29] = ($event: any) => ((isOtherPurposeChecked).value = $event)),
                  "set-field-value": _unref(recommendForm).setFieldValue
                }, null, 8, ["model-value", "textarea-value", "other-checked", "set-field-value"])
              ]),
              _createElementVNode("div", _hoisted_159, [
                _createElementVNode("a", {
                  class: _normalizeClass(["p-recommend-form__send", { 'disabled-link': isDisabledSubmit.value }]),
                  href: "#",
                  onClick: _withModifiers(updateRecommendData, ["prevent"])
                }, _hoisted_162, 10, _hoisted_160)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_163, [
        _createElementVNode("a", {
          class: "g-pagetop",
          href: "#",
          "aria-label": "ページトップへ戻る",
          onClick: _withModifiers(scrollToTop, ["prevent"])
        }, _hoisted_166, 8, _hoisted_164)
      ])
    ]),
    (isTeleportReady.value)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 0,
          to: "#recommend-footer"
        }, [
          _createElementVNode("a", {
            class: _normalizeClass(["p-recommend-form__send", { 'disabled-link': isDisabledSubmit.value }]),
            href: "#",
            onClick: _withModifiers(updateRecommendData, ["prevent"])
          }, _hoisted_169, 10, _hoisted_167)
        ]))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(RecommendModal, { "show-modal": showModal.value }, null, 8, ["show-modal"])
    ]))
  ], 64))
}
}

})